module.exports = __webpack_public_path__ + "img/facebook-32.f63d282c.png";